
/// <amd-module name="TFS/Admin/Groups/Pivots/GroupMembers/DataSource/GroupMembersPivotDataSource" />
import { IGroupsViewData } from "TFS/Admin/Groups/Common/Contracts";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

const membersPivotDataProvider = "ms.vss-admin-web.org-admin-group-members-data-provider";

export function getGroupMembersList(pageContext: IVssPageContext, requestParameters?: { [key: string]: any }): Promise<IGroupsViewData | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    return contributionService.getDataAsync<IGroupsViewData>(membersPivotDataProvider, requestParameters, true).then((result) => {
        return result;
    });
}
